import ProjectReportSlice from '@rd-web-markets/market/dist/technicalProof/projectReportSlice/ProjectReportSlice';
import React from 'react';
import ClientVisibilityControl from '../ClientVisibilityControl';
const ProjectReportSliceList = _ref => {
  let {
    handleTinyMce,
    handleSliceChange,
    handleChange,
    handleSubmit,
    key,
    index,
    slice,
    report,
    pageAccess,
    isClient,
    isDisabled
  } = _ref;
  const showClientVisibilityCheckbox = !isClient && report.technical_narrative_visibility_mode === 'custom';
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isClient && /*#__PURE__*/React.createElement(ClientVisibilityControl, {
    report: report,
    fieldName: "technical_narrative_visibility_mode",
    handleChange: handleChange,
    handleSubmit: handleSubmit,
    disabled: !pageAccess.canEditProjectDetails
  }), report.project_report_slices.filter(slice => slice.tab === 'narrative').filter(slice => slice.title !== 'conclusion').map((slice, index) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProjectReportSlice, {
    pageAccess: pageAccess,
    handleTinyMce: handleTinyMce,
    handleSubmit: handleSubmit,
    handleSliceChange: handleSliceChange,
    key: index,
    index: index,
    slice: slice,
    isDisabled: isDisabled,
    showClientVisibilityCheckbox: showClientVisibilityCheckbox
  }))));
};
export default ProjectReportSliceList;